import queryString from 'query-string'

export default function getQueryParamsFromStringObjectUtil (queryStr = window.location.search) {
  return queryString.parse(queryStr) || {}
}
